import React from 'react';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    const baseStyles = 'px-6 py-3 rounded-full font-semibold transition-all duration-300 active:scale-95 flex items-center justify-center gap-2';

    const variants = {
        primary: 'bg-green-600 text-white hover:bg-green-700 shadow-lg hover:shadow-xl',
        secondary: 'bg-white text-green-700 border-2 border-green-700 hover:bg-green-50',
        outline: 'bg-transparent text-green-700 border-2 border-green-200 hover:border-green-700 hover:bg-green-50',
        ghost: 'bg-transparent text-green-600 hover:bg-green-100 hover:text-green-700',
    };

    return (
        <button
            className={`${baseStyles} ${variants[variant]} ${className}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
